import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Transition } from 'react-transition-group';
import { useTranslation, Trans } from 'react-i18next';
import CancelIcon from './CancelIcon';

const customStyles = {
  buttonColor: (props) => ({
    backgroundColor: 'white',
    borderColor: 'white',
    color: props.tenant.primary,

    '&:hover': {
      backgroundColor: props.tenant.primary,
      border: '2px solid white',
      color: 'white',
      borderStyle: 'solid',
    },
  }),
  background: (props) => ({
    backgroundColor: `${props.tenant.primary}E9`,
  }),
};

const closeFooter = (e, consent) => {
  if (['Enter'].includes(e.key)) {
    consent();
  }
};

const defaultStyle = {
  transition: 'opacity 1000ms ease-in-out',
  transitionDelay: '1000ms',
  height: 0,
};

const transitionStyles = {
  entering: {
    height: '5vh',
  },
  entered: {
    height: 'auto',
  },
  exiting: {
    height: '5vh',
  },
  exited: {
    height: 0,
  },
};

const GDPR = ({ tenant, consent, classes, in: inProp }) => {
  const { t } = useTranslation();

  return (
    <Transition in={inProp} timeout={100}>
      {(state) => (
        <div
          style={{ ...defaultStyle, ...transitionStyles[state] }}
          className={['gdpr-footer', classes.background].join(' ')}
          data-cy="gdpr"
        >
          <div>
            <p className="text">
              <Trans>
                {t(
                  'Cookies are essential for this site to operate correctly and to provide you with requested services. We use cookies to understand and save your preferences for future visits and compile aggregate data about network traffic and network interaction so that we can offer better network experiences and tools in the future. By clicking ‘Accept’ or continuing to use this site, you agree to allow cookies to be placed.'
                )}
              </Trans>
            </p>
            <div
              className="cancel-container"
              tabIndex={0}
              onClick={() => consent()}
              onKeyDown={(e) => closeFooter(e, consent)}
              role="button"
              aria-label="close notice about cookies"
            >
              <CancelIcon color={tenant.primary} />
            </div>
          </div>
          <button
            data-cy="gdpr-accept"
            className={[
              classes.buttonColor,
              'button--primary',
              'gdpr-button',
            ].join(' ')}
            onClick={() => consent()}
            onKeyDown={(e) => closeFooter(e, consent)}
            type="button"
          >
            {t('Accept')}
          </button>
        </div>
      )}
    </Transition>
  );
};

export default withStyles(customStyles)(GDPR);

GDPR.propTypes = {
  tenant: PropTypes.object.isRequired,
  consent: PropTypes.func.isRequired,
  in: PropTypes.bool.isRequired,
};
